import { render } from "./MySelect.vue?vue&type=template&id=0aaebdcd&scoped=true"
import script from "./MySelect.vue?vue&type=script&lang=js"
export * from "./MySelect.vue?vue&type=script&lang=js"

import "./MySelect.vue?vue&type=style&index=0&id=0aaebdcd&lang=css"
import "./MySelect.vue?vue&type=style&index=1&id=0aaebdcd&scoped=scoped&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aaebdcd"]])

export default __exports__